export const modalProps = {
  "aria-labelledby": "modal-modal-title",
  "aria-describedby": "modal-modal-description",
};